module.exports = __webpack_public_path__ + "static/img/screen1.5945b093.png";